<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">{{ $t('lang.Commodity Management') }}</p>
      <p v-if="view=='add'" @click="cancelHandle">{{ $t('lang.Commodity Management') }}</p>
      <p v-if="view=='add'">>{{ $t('lang.Add') }}</p>
      <p v-if="view=='edit'" @click="cancelHandle">{{ $t('lang.Commodity Management') }}</p>
      <p v-if="view=='edit'">>{{ $t('lang.Edit') }}</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <el-form
        :inline="true"
        class="demo-form-inline"
      >
        <el-form-item :label="$t('lang.Commodity Number')">
          <el-input v-model="number" :placeholder="$t('lang.Commodity Number')" clearable maxlength="50"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Commodity State')">
          <el-select class="fixed-width-100"
                     clearable
                     v-model="status">
            <el-option
              v-for="item in statusList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.Organization')">
          <query-unit-tree @change="handleChange"/>
          <!--<el-cascader
            class="fixed-width-200"
            :options="unitList"
            :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }" v-model="unitNo"
            clearable></el-cascader>-->
        </el-form-item>
        <el-form-item :label="$t('lang.Commodity Type')">
          <el-select class="fixed-width-200"
                     clearable
                     v-model="type">
            <el-option
              v-for="item in showTypeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.Setup time')">
          <el-date-picker
            v-model="timeArr"
            type="datetimerange"
            range-separator="-"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            :start-placeholder="$t('lang.start time')"
            :end-placeholder="$t('lang.end time')">
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="onQueryBtnClick">{{ $t('lang.Inquire') }}</el-button>
        <el-button type="primary" @click="onAddBtnClick">{{ $t('lang.Add') }}</el-button>

      </el-form>
      <el-table
        :data="dataList"
        style="width: 100%;margin-bottom: 20px;"
        class="table-custom"
      >
        <el-table-column prop="number" :label="$t('lang.Commodity Number')" width="200"></el-table-column>
        <el-table-column prop="title" :label="$t('lang.Commodity Name')" width="200"></el-table-column>
        <el-table-column prop="type" :label="$t('lang.Commodity Type')" width="200">
          <template slot-scope="{row}">
            <div>{{typeList[+row.type] && typeList[+row.type].text}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="standard" :label="$t('lang.Commodity Spec')" width="200">
          <template slot-scope="{row}">
            <div>{{row.standard ? row.standard + 'V' : ''}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="title" :label="$t('lang.Stocks')" width="200">
          <template slot-scope="{row}">
            <div>{{row.stock ? row.stock : $t('lang.Unlimited')}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="price" :label="$t('lang.Price')" width="200"></el-table-column>
        <el-table-column prop="deposit" :label="$t('lang.Deposit')" width="200"></el-table-column>
        <el-table-column prop="worth" :label="$t('lang.Value')" width="200"></el-table-column>
        <el-table-column prop="duration" :label="$t('lang.Effective Time')" width="200">
          <template slot-scope="{row}">
            <div>{{row.duration ? row.duration / 86400000 + $t('lang.days') : ''}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="frequency" :label="$t('lang.Available Times')" width="200"></el-table-column>
        <el-table-column prop="status" :label="$t('lang.Commodity State')" width="200">
          <template slot-scope="{row}">
            <div>{{statusList[row.status] && statusList[row.status].text}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="unitName" :label="$t('lang.Organization')" width="250"></el-table-column>
        <el-table-column :label="$t('lang.Operating')" width="200" fixed="right">
          <template slot-scope="{row}">
            <div>
              <el-button type="primary" size="mini" @click="onTabBtnClick(row)">{{ $t('lang.Switch state') }}</el-button>
            </div>
            <div style="margin-top: 10px;">
              <el-button type="primary" size="mini" @click="onEditBtnClick(row)">{{ $t('lang.Edit') }}</el-button>
              <el-button type="primary"  size="mini" @click="onDeleteBtnClick(row)">{{ $t('lang.Delete') }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="dfcc">
        <el-pagination
          :current-page="beginIndex + 1"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10,20, 30, 40,50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="main-body" v-if="view == 'add'">
      <commodity-mgmt-add-view @addSuccess="addSuccessHandle" @cancel="cancelHandle"></commodity-mgmt-add-view>
    </div>
    <div class="main-body" v-if="view == 'edit'">
      <commodity-mgmt-edit-view :editData="editData" @editSuccess="editSuccessHandle"
                                @cancel="cancelHandle"></commodity-mgmt-edit-view>
    </div>
  </div>
</template>

<script>
import CommodityMgmtAddView from "./commodityMgmtAddView";
import CommodityMgmtEditView from "./commodityMgmtEditView";
import Utils from "../../utils/utils";
import {queryCommodity} from '../../api/product';
import queryUnitTree from '@/components/common/queryUnitTree';

export default {
  name: 'commodityMgmt',
  components: {CommodityMgmtEditView, CommodityMgmtAddView, queryUnitTree},
  data() {
    return {
      view: "list",
      number: "",
      status: "",
      statusList: [{
        id: '',
        text: this.$t('lang.All')
      }, {
        id: '1',
        text: this.$t('lang.On Sale')
      }, {
        id: '2',
        text: this.$t('lang.Off Sale')
      }],
      type: '',
      typeList: [
        {
          id: '',
          text: '全部'
        }, {
          id: '1',
          text: '直流充电服务'
        }, {
          id: '2',
          text: this.$t('lang.Swapping Service')
        }, {
          id: '3',
          text: '交流充电服务'
        }, {
          id: '4',
          text: this.$t('lang.Timer Card')
        }, {
          id: '5',
          text: '充电卡'
        }, {
          id: '6',
          text: this.$t('lang.Battery')
        }, {
          id: '7',
          text: '电池适配器'
        }, {
          id: '8',
          text: '充电柜充电服务'
        }, {
          id: '9',
          text: '电动车'
        }, {
          id: '10',
          text: '租车卡'
        },
        {
          text: ''
        },
        {
          id: '12',
          text: '充电卡（充电柜）'
        },
        {
          id: '13',
          text: '保险'
        },
        {
          id: '14',
          text: '电池附属品'
        },
        {
          id: '15',
          text: this.$t('lang.Measured Card')
        }
      ],
      beginTime: '',
      endTime: '',
      unitNo: [],
      unitList: [],
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      total: 0,
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: true,
      dataList: [],
      editData: {}
    }
  },
  computed: {
    showTypeList() {
      return this.typeList.filter((el) => {
        return ['2', '4', '6', '15'].includes(el.id)
      })
    },
    timeArr: {
      set(e) {
        if(e && e.length) {
          this.beginTime = e[0]
          this.endTime = e[1]
        } else {
          this.beginTime =''
          this.endTime = ''
        }
      },
      get() {
        if(this.beginTime && this.endTime) {
          return [this.beginTime, this.endTime]
        } else {
          return []
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.number) {
      this.number = this.$route.query.number;
    }
    this.endTime = Utils.getCurrentDate() + " 23:59";
    this.queryCommodityList();
    this.getUnitMember();
  },
  methods: {
    // select组件
    handleChange(val) {
      this.unitNo = val;
    },
    /**
     * 个数改变
     * @param pageSize
     */
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.queryCommodityList();
    },
    /**
     * 页面跳转
     * @param page
     */
    handleCurrentChange(page = 1) {
      this.beginIndex = page - 1;
      this.queryCommodityList();
    },
    async queryCommodityList () {
      let self = this;
      let params = {
        number: this.number,
        status: this.status,
        type: this.type,
        unitNo: this.unitNo[this.unitNo.length - 1],
        beginTime: '',
        endTime: '',
        beginIndex: this.beginIndex,
        pageSize: this.pageSize
      };
      params.beginTime = this.$changeTime.sendTime(this.beginTime, 'YYYY-MM-DD HH:mm');
      params.endTime = this.$changeTime.sendTime(this.endTime, 'YYYY-MM-DD HH:mm');
      const res = await queryCommodity(params)
      self.dataList = res.ldata;
      self.total = res.mdata.total;
    },

    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryCommodityList();
    },
    onAddBtnClick() {
      this.view = 'add';
    },
    // 编辑
    onEditBtnClick(data) {
      console.log(data, 'data');
      this.view = 'edit';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    addSuccessHandle() {
      this.view = 'list';
      this.beginIndex = 0;
      this.queryCommodityList();
    },
    editSuccessHandle() {
      this.view = 'list';
      this.queryCommodityList();
    },
    cancelHandle() {
      this.view = 'list';
      this.queryCommodityList();
    },
    onTabBtnClick(item) {
      let self = this;
      this.$confirm(this.$t('lang.Whether to confirm the switching status'), this.$t('lang.Tips'), {
        type: 'warning'
      }).then(() => {
        self.changeStatus(item.number);
      }).catch(() => {

      });
    },
    changeStatus(number) {
      let self = this;
      let params = {
        number: number
      };
      this.$http.post('/managementPlatform/admin/updateCommodityStatus', this.$qs.stringify(params)).then(function (response) {
        console.log(res, '返回res');
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || this.$t('lang.failure'),
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: this.$t('lang.Success'),
          center: true
        });
        self.queryCommodityList();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onDeleteBtnClick(item) {
      let self = this;
      this.$confirm(this.$t('lang.Confirm deletion?'), this.$t('lang.Tips'), {
        type: 'warning'
      }).then(() => {
        self.deleteCommodity(item.number);
      }).catch(() => {

      });
    },
    deleteCommodity(number) {
      let self = this;
      let params = {
        number: number
      };
      this.$http.post('/managementPlatform/admin/deleteCommodity', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || self.$t('lang.failure'),
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: self.$t('lang.Success'),
          center: true
        });
        self.queryCommodityList();
      }).catch(function (response) {
        console.log(response);
      });
    },
    getUnitMember() {
      let self = this;
      let params = {
        authorityType: 230
      }
      this.$http.post('/managementPlatform/unit/queryManagedUnit', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.unitList = res.mdata.unitTree;
      }).catch(function (response) {
        console.log(response);
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-200 {
      width: 200px;
    }

    .fixed-width-300 {
      width: 300px;
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #BEE6B3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commodityMgmt/commodityMgmt.vue